document.addEventListener("click", function (e) {
	var target = e.target;

	if (target.classList.contains("js-activate")) {
        e.preventDefault();
		var dataTargetAttr = target.getAttribute("data-target");
		var targetElement = document.querySelector(dataTargetAttr);
		targetElement.classList.add("is-active");
	}

    if (target.classList.contains("js-deactivate")) {
        e.preventDefault();
		var dataTargetAttr = target.getAttribute("data-target");
		var targetElement = document.querySelector(dataTargetAttr);
		targetElement.classList.remove("is-active");
	}
    
    if (target.classList.contains("js-toggleActivate")) {
        e.preventDefault();
		var dataTargetAttr = target.getAttribute("data-target");
		var targetElement = document.querySelector(dataTargetAttr);
		targetElement.classList.toggle("is-active");
	}
});